
export const FLV_GRADIENT_PINK = `linear-gradient(130deg, rgba(245,169,202,1) 0%, rgba(248,194,217,1) 44%, rgba(252,226,237,1) 100%);`
export const FLV_GRADIENT_GOLD = `linear-gradient(180deg, rgba(255,255,255,0) 14%, rgba(255,252,223,1) 53%, rgba(255,245,132,1) 100%);`
export const FLV_GRADIENT_BLUE = `linear-gradient(180deg,rgba(217,241,253,0.5) 33%, rgba(217,241,253,1) 100%);`

export const FLV_BACKGROUND_GRADIENT_LIGHT = `background-image:linear-gradient(130deg,rgba(245,169,202,1) 0%,rgba(248,194,217,1) 44%,rgba(252,226,237,1) 100%)`
export const FLV_BACKGROUND_GRADIENT_DARK =  `background-image:linear-gradient(130deg,rgba(100,23,95,1) 0%,rgba(248,194,217,1) 44%,rgba(252,226,237,1) 100%)`
export const FLV_BACKGROUND_GRADIENT_BLUE_TO_PINK = `linear-gradient(#53dee9, #D531C9)`

export const FLV_PAGE_BACKGROUND_GRADIENT_LIGHT = `height: 100%;margin: 0;background-attachment:fixed;background-image:linear-gradient(130deg,rgba(245,169,202,1) 0%,rgba(248,194,217,1) 44%,rgba(252,226,237,1) 100%)`
export const FLV_PAGE_BACKGROUND_GRADIENT_DARK =  `height: 100%;margin: 0;background-attachment:fixed;background-image:linear-gradient(130deg,rgba(100,23,95,1) 0%,rgba(152, 31, 144,1) 44%,rgba(252,226,237,1) 100%)`

export const FLV_BACKGROUND = '#f5a9ca'
export const FLV_BACKGROUND_LIGHT = '#f9dce8'
export const FLV_TEXT = '#a6269e'


export const FLV_MAIN_BYSANTINE = '#A6269E'
export const FLV_MAIN_STEEL_PINK = '#D531C9'
export const FLV_MAIN_WHEAT = '#F7DFB6'
export const FLV_MAIN_PIGGY_PINK = '#F9DCE8'
export const FLV_MAIN_FRENCH_PASS = '#D9F1FD'

export const FLV_DARK_MIDNIGHT_DARKENED = '#65005D'
export const FLV_DARK_MIDNIGHT = '#64175F'
export const FLV_DARK_DARK_MAGENTA = '#981F90'
export const FLV_DARK_PULLMAN_BROWN = '#6E4A0C'
export const FLV_DARK_TYRIAN_PURPLE = '#691236'
export const FLV_DARK_VENICE_BLUE = '#064C70'

export const FLV_LIGHT_STRIKE_MASTER = '#BF92C0'
export const FLV_LIGHT_FUCHSIA_PINK = '#D897D8'
export const FLV_LIGHT_DRY_WHEAT = '#F7E9D3'
export const FLV_LIGHT_AMOUR = '#F7E8EF'
export const FLV_LIGHT_SAIL = '#E9F6FD'


/*
  gradients: {
    pink: {
      illusion: '#F5A9CA',
      chantilly: '#F8C2D9',
      wispPink: '#FCE2ED',
    },
    gold: {
      white: '#FFFFFF00',
      scotchMist: '#FFFCDF',
      parisDaisy: '#FFF584',
    },
    blue: {
      frenchPass: '#D9F1FD',
    }
  },
*/